<template>

    <div class="loginPage cardBox">
        <div class="cardBody">

            <div class="loginBox">
                <img class="logo" src="@/assets/images/logo.png">
                <h2>宫颈细胞TBS智能诊断系统</h2>

                <dl>
                    <dd>
                        <label class="inputItem">
                            <span class="icon userIcon"></span>
                            <input type="text" v-model="param.username" placeholder="请输入账号"></input></label>
                    </dd>
                    <dt class="userdailog"></dt>
                    <dd>
                        <label class="inputItem">
                            <span class="icon passIcon"></span>
                            <input type="password" v-model="param.password" placeholder="请输入密码"></input></label>
                    </dd>
                    <dt class="passdailog"></dt>
                    <dd>
                        <label class="radioBox" @click="saveForm">
                            <span class="checkIcon " :class="isSave?'on':''"></span>
                            记住密码
                        </label>
                        <label class="radioBox" @click="autoTrue">
                            <span class="checkIcon" :class="autoLogin?'on':''"></span>
                            自动登录
                        </label>
                    </dd>
                </dl>

                <button class="send" @click="goHome">登录</button>




            </div>

        </div>
        <div class="footer">
            <p>Copyright © 2019 北京华健蓝海医疗科技有限责任公司. All rights reserved.</p>
        </div>
    </div>

</template>


<style lang="scss" scoped>
    @import './Login.scss';
</style>


<script>
    export default {
        data() {
            return {
                param: {
                    username: '',
                    password: '',
                },
                isSave: '',
                autoLogin: '',
            }
        },
        components: {

        },
        created() {
            let that = this;
            that.param = localStorage.getItem('param')?JSON.parse(localStorage.getItem('param')):that.param;
            that.isSave = localStorage.getItem('isSave')?JSON.parse(localStorage.getItem('isSave')):false;
            that.autoLogin = localStorage.getItem('autoLogin')?JSON.parse(localStorage.getItem('autoLogin')):false;

            if (that.isSave && that.autoLogin) {
                that.$toast.loading({
                    message: '加载中...',
                });
                setTimeout(() => {
                    that.$toast.clear();
                    that.goHome();
                }, 2000)


            }

            document.onkeydown = function (e) {
                var key = window.event.keyCode;
                if (key == 13) {
                    that.goHome();
                }
            }
        },
        mounted() {
            let that = this;
        },
        methods: {
            saveForm() {
                let that = this;
                that.isSave = that.isSave ? false : true;
            },
            autoTrue() {
                let that = this;
                that.autoLogin = that.autoLogin ? false : true;
            },
            goHome() {
                let that = this;


                let params=new Object();

                params.username=that.param.username;
                params.password=that.md5(that.param.password);

                that.ajax.post('sys/login', params).then(res => {
                    sessionStorage.setItem('user', JSON.stringify(res.data));
                    that.$router.replace({ name: 'Home' });
                    if (that.isSave) {
                        localStorage.setItem('param', JSON.stringify(that.param));
                    } else {
                        localStorage.setItem('param', JSON.stringify({ username: '', password: '' }));
                    }
                    localStorage.setItem('isSave', that.isSave);
                    localStorage.setItem('autoLogin', that.autoLogin);

                })
            },
            login() {
                let that = this;
            },
            demoAdd() {
                let that = this;
                return ;
                let param = {
                    username: 'text',
                    password: '123456',
                    nickName: '阿斌哥',
                    sex: 1,
                    idCard: '',
                    email: '',
                    phone: '',
                    address: '',
                    createdBy: '',
                    status: '',
                    roleId: '',
                }
                that.ajax.post('user/add', param).then(res => {
                    console.log(res);
                })
            }

        },
    }
</script>